export const getPriceDiff = (desiredTier, currentTier, tiers, currency) => {
  const currentTierPrice = getPriceForTier(currentTier, tiers, currency);
  const desiredTierPrice = getPriceForTier(desiredTier, tiers, currency);
  return parseFloat(desiredTierPrice.get('amount', 0)) - parseFloat(currentTierPrice.get('amount', 0));
};

export const getPriceForTier = (tierLevel, tiers, currency) => {
  return tiers.getIn([tierLevel.toString(), 'prices', currency.get('value')]);
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/pricingCalculations.js